import { render, staticRenderFns } from "./stream-setting.vue?vue&type=template&id=3b434536"
import script from "./stream-setting.vue?vue&type=script&lang=js"
export * from "./stream-setting.vue?vue&type=script&lang=js"
import style0 from "./stream-setting.vue?vue&type=style&index=0&id=3b434536&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports